import { render, staticRenderFns } from "./RequestNewPasswordModal.vue?vue&type=template&id=0ca9f1af&scoped=true"
import script from "./RequestNewPasswordModal.vue?vue&type=script&lang=js"
export * from "./RequestNewPasswordModal.vue?vue&type=script&lang=js"
import style0 from "./RequestNewPasswordModal.vue?vue&type=style&index=0&id=0ca9f1af&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca9f1af",
  null
  
)

export default component.exports